/** State updater that drops one field's error once the user edits that field. */
export const clearError =
  (key: string) =>
  (errors: Record<string, string>): Record<string, string> => {
    if (!(key in errors)) return errors;
    const { [key]: _, ...rest } = errors;
    return rest;
  };
